<template>
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                Upload & View Holidays
              </div>
            </div>
          </v-col>
          <v-col>
            <v-card-actions>
              <router-link slot="right" :to="{ name: 'amsSchedulingDashboard' }">
                <v-btn
                  elevation="1"
                  absolute
                  right
                  top
                >
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
              </router-link>
            </v-card-actions>
          </v-col>
          <v-col cols="12" md="6" lg="8" sm="6" xs="12">
            <v-card-actions v-if="accessHoliday === false">
              <v-btn color="accent" class="white--text" elevation="1" @click="modalOk = true" right absolute style="margin-top: 120px;">
                Upload Holiday List
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-row v-if="isSuperAdmin === true || accessHoliday === true">
          <v-col cols="12">
            <v-card-actions>
              Holidays Uploaded By
              &nbsp;<v-chip>{{ totalZoneHolidaysCount + '/' + totalFranchiseesCount }}</v-chip>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-container class="bg-surface-variant" v-if="isSuperAdmin === true || accessHoliday === true">
        <v-row no-gutters style="background-color: #D3D3D3;">
          <v-col
            cols="12"
            sm="3"
          >
            <v-sheet class="ma-2 pa-2">
              EAST : {{ totalEast + '/' + totalofEast }}
            </v-sheet>
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
            <v-sheet class="ma-2 pa-2">
              WEST : {{ totalWest + '/' + totalofWest }}
            </v-sheet>
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
            <v-sheet class="ma-2 pa-2">
              NORTH : {{ totalNorth + '/' + totalofNorth }}
            </v-sheet>
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
            <v-sheet class="ma-2 pa-2">
              SOUTH : {{ totalSouth + '/' + totalofSouth }}
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
      <hr />
      <v-row>
          <v-col cols="12" md="2" sm="2" xs="12">
            <v-autocomplete
              key="id"
              :items="academicYears"
              v-model="academicYearID"
              item-text="academicYear"
              item-value="id"
            >
              <template v-slot:label> Academic Year </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="isSuperAdmin === true || accessHoliday === true" cols="12" md="2" sm="2" xs="12">
            <v-autocomplete
              key="id"
              :items="zones"
              v-model="zoneID"
              item-text="name"
              item-value="id"
            >
              <template v-slot:label> Select Zone </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="isSuperAdmin === true || accessHoliday === true" cols="12" md="2" sm="2" xs="12">
            <v-autocomplete
              name="centertype"
              :items="franchisees"
              v-model="selectedFranchisee"
              key="id"
              item-text="companyName"
              item-value="id"
            >
              <template v-slot:label> Franchisee Name </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="isSuperAdmin === true || accessHoliday === true" cols="12" md="2" sm="2" xs="12">
            <v-autocomplete
              name="id"
              :items="status"
              v-model="selectStatus"
              key="id"
              item-text="name"
              item-value="id"
            >
              <template v-slot:label> Status </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2" xs="12">
            <div class="d-flex justify-end caption">
              <v-btn

                small
                id="apply"
                color="success"
                elevation="1"
                type="submit"
                class="ml-2 mt-5"
                @click="getAllZoneHolidayCountAndList()"

              >
                <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                Proceed
              </v-btn>
              <v-btn

                small
                elevation="1"
                type="reset"
                @click="resetAll()"
                class="ml-2 mt-5"
              >
                <v-icon left size="18"> mdi-restart</v-icon> Clear
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <v-data-table
              item-key="id"
              :headers="headers"
              :items="uploadedDataList"
            >
              <template v-slot:item.status="{ item }">
                <span class="has-text-success" v-if="item.status === 'Uploaded'"
                  >Uploaded</span>
                <span class="has-text-danger" v-else>Pending</span>
                <!-- &nbsp;&nbsp;&nbsp;&nbsp;<v-btn
                  v-if="item.status === 'Uploaded'"
                  small
                  color="primary"
                  @click="viewHolidayYearandDate(item)"
                >
                <v-icon>mdi-eye</v-icon> View
                </v-btn> -->
              </template>
              <template v-slot:item.view="{ item }">
                <v-btn
                  v-if="item.status === 'Uploaded'"
                  small
                  color="primary"
                  @click="viewHolidayYearandDate(item)"
                >
                  <v-icon>mdi-eye</v-icon> View
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-dialog
          persistent
          v-model="modalOk"
          max-width="500"
          :active="modalOk"
          :on-cancel="
            () => {
              ;(modalOk = false), clearData()
            }
          "
        >
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Upload Holiday List</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(modalOk = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-row>
            <v-col cols="12" md="4" sm="2" xs="12">
              <div class="column ">
              <section class="text-is-centered">
                <b-field>
                  <b-upload v-model="dropFiles" @input="csvToJsonInput(dropFiles)" accept=".csv" :multiple="false" drag-drop title="Please do upload .csv file only">
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Choose File</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>

                <div class="tags" v-if="dropFiles.name">
                  <span class="tag is-primary">
                    {{ dropFiles.name }}
                    <button class="delete is-small" type="button" @click="deleteDropFile()"></button>
                  </span>
                </div>
              </section>
            </div>
          </v-col>
          <v-col>
            <div class="column has-text-centered">
              <a class="button is-link" href="https://stagecdn.brainbees.com/education/totsweb/stage/portal19/uploadHolidaySampleFile.csv?1234" right download> <v-icon left color="white">mdi-download</v-icon> Sample File Format</a>
            </div>
          </v-col>
          </v-row>
          <footer class="column has-text-centered">
            <!-- <button class="button is-success" type="submit" @click="uploadFile(dropFiles)">Upload</button> -->
            <v-btn
              class="ml-1 mb-1"
              outlined
              big
              dense
              color="success"
              elevation="0"
              @click="uploadFile(dropFiles)"
            >
              Upload
            </v-btn>
            <v-btn
              class="ml-1 mb-1"
              outlined
              big
              id="apply"
              color="error"
              elevation="1"
              type="submit"
              @click="clearData()"
            >
              Cancel
            </v-btn>
          </footer>
        </v-card>
        </v-dialog>
        <v-dialog
          persistent
          v-model="failedUploadFile"
          max-width="600"
          :active="failedUploadFile"
          :on-cancel="
            () => {
              ;(failedUploadFile = false), clearData()
            }
          "
        >
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title>File Failed Uploading</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="
                    () => {
                      ;(failedUploadFile = false), clearData()
                    }
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <!-- <v-row>
              <v-col cols="12" md="4" sm="2" xs="12"> -->
                <div class="column has-text-centered" style="margin-top: 20px;">
                  <img src="https://stagecdn.brainbees.com/education/intellitots/ams/Download_Failed.png">
                </div>
                <div class="column has-text-centered">
                  <v-btn color="accent" class="white--text" elevation="1" @click="downloadFailedFile()">Download Failed File</v-btn>
                </div>
              <!-- </v-col>
            </v-row> -->
            <!-- <v-row> -->
              <footer class="column has-text-centered" >
                <div style="color: red;">Note: Your file upload has failed. Please download the failed file, check the reason for the failure, and re-upload the file</div>
              </footer>
            <!-- </v-row> -->
          </v-card>
        </v-dialog>
        <v-dialog
          persistent
          v-model="viewHolidayList"
          max-width="500"
          :active="viewHolidayList"
          :on-cancel="
            () => {
              ;(viewHolidayList = false), clearData()
            }
          "
        >
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title>Holiday List</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="
                    () => {
                      ;(viewHolidayList = false), clearData()
                    }
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
              <div>
                <v-data-table
                  item-key="id"
                  :headers="headers1"
                  :items="holidayYearandDate"
                ></v-data-table>
              </div>
            </v-card>
          </v-card>
        </v-dialog>
      </v-card>
</v-container>
</template>

<script>
import Papa from 'papaparse'
import csvtojsonV2 from 'csvtojson'
import constants from '@/utils/constants'
import stores from '@/stores'
import moment from 'moment'
import { mapGetters } from 'vuex'
import ExportUtility from '@/utils/exportUtility'
import Utils from '@/utils'

export default {
  name: 'uploadAndViewHoliday',
  data () {
    return {
      isSuperAdmin: false,
      headers: [
        {
          text: 'Zone',
          value: 'zone.name',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Franchisee',
          value: 'franchisee.companyName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Uploaded Date',
          value: 'createdAt',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Status',
          value: 'status',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Action',
          value: 'view',
          align: 'center'
        }
        // { text: 'Status', value: 'action', align: 'center' }
      ],
      modalOk: false,
      dropFiles: [],
      dateformatcheck: false,
      downloadLink: null,
      failedUploadFile: false,

      academicYears: [],
      academicYearID: '',
      zones: [],
      zoneID: '',
      franchisees: [],
      selectedFranchisee: '',
      status: [
        { id: 'Uploaded', name: 'Uploaded' },
        { id: 'Pending', name: 'Pending' }
      ],
      selectStatus: '',
      totalZoneHolidaysCount: '',
      totalFranchiseesCount: '',
      totalofEast: '',
      totalEast: '',
      totalofWest: '',
      totalWest: '',
      totalofNorth: '',
      totalNorth: '',
      totalofSouth: '',
      totalSouth: '',
      uploadedDataList: [],
      formatDate: '',
      viewHolidayList: false,

      headers1: [
        {
          text: 'Academic Year',
          value: 'franchiseeAcademicYear.academicYear',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Holiday Date',
          value: 'date',
          sortable: true,
          align: 'center'
        }
      ],
      holidayYearandDate: [],
      accessHoliday: false,
      failedUploadFileData: ''
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.academicYearChange()
    }
  },
  created: async function () {
    let userStore = stores.user
    this.isSuperAdmin = userStore.ACL.superAdmin
    if (this.isSuperAdmin === false) {
      for (const item of userStore.roles) {
        if (item.role === 'AMSHolidayUpload') {
          this.accessHoliday = true
        }
      }
    }
    this.totalZoneHolidaysCount = ''
    this.totalFranchiseesCount = ''
    await this.getAcademicYear()
    await this.getZones()
    await this.getFranchisee()
    // await this.getAllZoneHolidayCountAndList()
    await this.onFranchiseeChange()
  },
  methods: {
    getAcademicYear: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        const data = response.data
        this.academicYears = data.rows
        // const currentAcademicYear = Utils.getCurrentAcademicYear()
        // let academicYear = this.academicYears.find((y) => {
        //   return y.academicYear.trim() === currentAcademicYear.trim()
        // })
        // this.academicYearID = academicYear ? academicYear.id : ''
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getZones: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/get/zones`
        )
        this.zones = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getFranchisee: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        const data = response.data
        this.franchisees = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getAllZoneHolidayCountAndList: async function () {
      try {
        this.totalZoneHolidaysCount = ''
        this.totalFranchiseesCount = ''
        let payload = {}
        if (this.academicYearID) {
          payload.academicYearId = this.academicYearID
        }
        if (this.zoneID) {
          payload.zoneId = this.zoneID
        }
        if (this.selectedFranchisee) {
          payload.franchiseeId = this.selectedFranchisee
        }
        if (this.selectStatus) {
          payload.status = this.selectStatus
        }
        if (this.isSuperAdmin === false) {
          payload.franchiseeId = stores.user.userInfo.franchisee[0].franchiseeID
        }

        let response = await http.post(
          `${constants.API_URL}/api/amsScheduling/holiday/getHolidayUploadList`,
          payload
        )
        this.uploadedDataList = response.data.data

        for (const item of this.uploadedDataList) {
          item.createdAt = item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : ''
        }

        for (const item of response.data.totalCounts) {
          this.totalFranchiseesCount = Number(this.totalFranchiseesCount) + Number(item.total_franchisees)
          this.totalZoneHolidaysCount = Number(this.totalZoneHolidaysCount) + Number(item.franchisee_holiday_upload_count)

          if (item.franchiseeZone === 'East') {
            this.totalofEast = item.total_franchisees
            this.totalEast = item.franchisee_holiday_upload_count
          } else if (item.franchiseeZone === 'West') {
            this.totalofWest = item.total_franchisees
            this.totalWest = item.franchisee_holiday_upload_count
          } else if (item.franchiseeZone === 'North') {
            this.totalofNorth = item.total_franchisees
            this.totalNorth = item.franchisee_holiday_upload_count
          } else if (item.franchiseeZone === 'South') {
            this.totalofSouth = item.total_franchisees
            this.totalSouth = item.franchisee_holiday_upload_count
          }
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    resetAll: function () {
      this.academicYearID = ''
      this.selectedFranchisee = ''
      this.zoneID = ''
      this.selectStatus = ''
      this.getAllZoneHolidayCountAndList()
    },
    readerFile: function (file, onLoadCallback) {
      if (file === null) {
        this.clearData()
        this.loadingComponent.close()
        this.modalOk = false
        return this.$buefy.dialog.alert({
          message: 'Upload only .csv file please',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      var reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    csvToJsonInput: async function (files) {
      this.loadingComponent = this.$buefy.loading.open()
      this.isResponse = false
      // let self = this
      // if (files.length > 1) {
      //   this.dropFiles.splice(0, 1)
      // }
      // let file = files[0]

      this.readerFile(files, async e => {
        self.jsonData = await csvtojsonV2().fromString(e.target.result)
        this.failedUploadFileData = this.validateDates(self.jsonData)
        if (this.dateformatcheck === true) {
          this.modalOk = false
          this.failedUploadFile = true
        }
      })
      this.loadingComponent.close()
    },
    validateDates (data) {
      const holidayDateFormat = /^\d{2}\/\d{2}\/\d{4}$/
      const academicDateFormat = /^\d{4}-\d{4}$/
      return data.map(row => {
        if (!holidayDateFormat.test(row['Date of Holiday'])) {
          this.dateformatcheck = true
          return {
            ...row,
            Reason: 'Holiday Date is incorrect'
          }
        }
        const [day, month] = row['Date of Holiday'].split('/').map(Number)
        if (month < 1 || month > 12 || day < 1 || day > 31) {
          this.dateformatcheck = true
          return {
            ...row,
            Reason: 'Holiday Date is incorrect'
          }
        }
        if (!academicDateFormat.test(row['Academic Year'])) {
          this.dateformatcheck = true
          return {
            ...row,
            Reason: 'Academic Year is incorrect'
          }
        }
        return row
      })
    },
    downloadFailedFile () {
      ExportUtility.convertToCsv(this.failedUploadFileData, 'Failed Upload File')
    },
    generateCSV (data) {
      const csv = Papa.unparse(data)
      const blob = new Blob([csv], { type: 'text/csv' })
      const url = URL.createObjectURL(blob)
      this.downloadLink = url
    },
    deleteDropFile () {
      this.dropFiles = []
    },
    clearData () {
      this.dropFiles = []
      this.modalOk = false
      this.dateformatcheck = false
      this.getAllZoneHolidayCountAndList()
    },
    uploadFile: async function (files) {
      try {
        let data = ''
        this.readerFile(files, async e => {
          try {
            if (this.isSuperAdmin === true) {
              if (this.franchisee.id === '') {
                this.modalOk = false
                this.dropFiles = []
                return this.$buefy.dialog.alert({
                  message: 'Please Select Franchisee',
                  type: 'is-danger',
                  hasIcon: true,
                  animation: 'zoom-out',
                  size: 'is-medium',
                  icon: ' mdi-exclamation',
                  iconPack: 'mdi',
                  ariaRole: 'alertdialog',
                  ariaModal: true
                })
              }
            }
            self.jsonData = await csvtojsonV2().fromString(e.target.result)
            data = self.jsonData.map(holiday => ({
              academicYear: holiday['Academic Year'],
              date: holiday['Date of Holiday']
            }))
            let franchiseeId = ''
            if (this.isSuperAdmin === true) {
              franchiseeId = this.franchisee.id
            } else if (stores.user.userInfo.franchisee.length >= 0) {
              franchiseeId = stores.user.userInfo.franchisee[0].franchiseeID
            }
            let response = await http.post(
              `${constants.API_URL}/api/amsScheduling/holiday/uploadHolidays`,
              {
                franchiseeId: franchiseeId,
                data
              }
            )

            if (response.status === 200 && response.data.status === 417) {
              this.modalOk = false
              this.dropFiles = []
              return this.$buefy.dialog.alert({
                type: 'is-info',
                message: response.data.errorResponse[0].reason,
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            if (response.status === 200 && response.data.status === 200) {
              this.modalOk = false
              this.dropFiles = []
              this.getAllZoneHolidayCountAndList()
              return this.$buefy.dialog.alert({
                type: 'is-info',
                message: 'Save Successful',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
          } catch (e) {
            this.loadingComponent.close()
            this.modalOk = false
            this.dropFiles = []
            const errorMessage = (e && e.response && e.response.data.message) || e.message

            return this.$buefy.dialog.alert({
              message: errorMessage,
              type: 'is-danger',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',
              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        })
      } catch (e) {
        this.$dialog.notify.info('No File Selected', {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },

    viewHolidayYearandDate: async function (item) {
      this.viewHolidayList = true

      const response = await http.post(
        `${constants.API_URL}/api/amsScheduling/holiday/holidayList`,
        {
          'holidayUploadId': item.id
        }
      )
      this.holidayYearandDate = response.data
      for (const item of this.holidayYearandDate) {
        item.date = item.date ? moment(item.date).format('DD/MM/YYYY') : ''
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true

        if (this.franchisee) {
          this.selectedFranchisee = this.franchisee.id
        } else {
          this.selectedFranchisee = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (!this.franchisee.id) {
          Utils.helper.openDrawer(this)
        } else {
          // Utils.helper.openDrawer(this, false)
          this.getAllZoneHolidayCountAndList()
        }
        this.inProgress = false
      }
    },
    academicYearChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
        this.getAllZoneHolidayCountAndList()
      }
    }
  }
}
</script>
<style scoped>
.section {
    padding: 0;
  }

.custom-column {
  background-color: lightblue; /* Just for visual clarity */
  padding: 10px;
  text-align: center;
}
</style>
